import { ADD_CLIENT, ADD_NOTICE, CLIENT_DATA, CLIENT_DETAILS, NOTICE_DATA, NOTICE_DETAILS, ADD_PROJECT_DATA, ADD_CUSTOMER_DATA, CUSTOMER_LIST, ADD_DESIGNATION_DATA, EMAIL_DATA, INSERT_REPORT_DATA, REPORT_ISSUE_LIST, HOLIDAY_LIST, ADD_HOLIDAY_DATA, PROJECT_ACCESS_LIST, ADD_TEAM_MEMBER, RELEASE_TEAM_MEMBER, PENDING_ISSUE_LIST, REPORT_CLOSED_LIST, NOTIFICATION_LIST, NOTIFICATION_UPDATE, NOTIFICATION_CLEAR } from "./ActionType";

const initialValue = {
    addClient: [],
    clientDetails: [],
    clientDataById: [],
    addNotice: [],
    noticeDetails: [],
    noticeDataById: [],
    addProject: [],
    customerlist: [],
    addcustomerdata: [],
    adddesingationdata: [],
    emaildata: [],
    insertreportData: [],
    reportIssueList: [],
    pendingIssueList: [],
    closedIssueList: [],
    notificationList: [],
    holidaylist: [],
    updateholidaydata: [],
    projectAccessList: [],
    addTeamMember: [],
    releaseTeamMember: [],
    notificationUpdate: [],

}

export const configReducer = (store = initialValue, { type, payload }) => {

    if (type === ADD_CLIENT) {
        return {
            ...store, addClient: payload || [],
        };
    } else if (type === CLIENT_DETAILS) {
        return {
            ...store, clientDetails: payload || [],
        };
    } else if (type === CLIENT_DATA) {
        return {
            ...store, clientDataById: payload || [],
        };
    } else if (type === ADD_NOTICE) {
        return {
            ...store, addNotice: payload || [],
        };
    } else if (type === NOTICE_DETAILS) {
        return {
            ...store, noticeDetails: payload.noticeDtoList || [],
        };
    } else if (type === NOTICE_DATA) {
        return {
            ...store, noticeDataById: payload || [],
        };
    } else if (type === ADD_PROJECT_DATA) {
        return {
            ...store,
            addProject: payload
        };
    } else if (type === ADD_CUSTOMER_DATA) {
        return {
            ...store,
            addcustomerdata: payload
        };
    } else if (type === CUSTOMER_LIST) {
        return {
            ...store,
            customerlist: Array.isArray(payload) ? payload : [],
        };
    } else if (type === ADD_DESIGNATION_DATA) {
        return {
            ...store,
            adddesingationdata: payload
        };
    } else if (type === EMAIL_DATA) {
        return {
            ...store,
            emaildata: Array.isArray(payload) ? payload : [],
        };
    } else if (type === INSERT_REPORT_DATA) {
        return {
            ...store,
            insertreportData: payload
        };
    } else if (type === REPORT_ISSUE_LIST) {

        return {
            ...store,
            reportIssueList: payload?.reportIssueDtoList || [],
        };
    } else if (type === HOLIDAY_LIST) {
        return { ...store, holidaylist: payload.holidayList || [] };
    } else if (type === ADD_HOLIDAY_DATA) {
        return {
            ...store,
            updateholidaydata: payload
        };
    } else if (type === PROJECT_ACCESS_LIST) {
        return { ...store, projectAccessList: payload.projectAccessList || [] };
    } else if (type === ADD_TEAM_MEMBER) {
        return {
            ...store,
            addTeamMember: payload
        };
    } else if (type === RELEASE_TEAM_MEMBER) {
        return {
            ...store,
            releaseTeamMember: payload
        };
    } else if (type === PENDING_ISSUE_LIST) {
        return {
            ...store,
            pendingIssueList: payload?.reportIssueDtoList || [],
        };
    } else if (type === REPORT_CLOSED_LIST) {
        return {
            ...store,
            closedIssueList: payload?.reportIssueDtoList || [],
        };

    } else if (type === NOTIFICATION_LIST) {
        return {
            ...store,
            notificationList: payload || [],
        };
    } else if (type === NOTIFICATION_UPDATE) {
        return {
            ...store,
            notificationUpdate: payload
        };
    } else if (type === NOTIFICATION_CLEAR) {
        return {
            ...store,
            notificationList: []
        };
    }

    return store
}